import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  de: {
    global: {
      cancel: "Abbrechen",
      password: "Kennwort",
      email: "E-Mail",
      passwordMessage: "Mindestens 6 Buchstaben",
      invalidEmail: "Ungültige E-Mail",
      cookieQuestion:
        "Diese Seite verwendet für eine personalisierte und sichere Nutzung Cookies. Cookies ermöglichen es uns, das Nutzerverhalten zu analysieren und die Website zu verbessern. Durch Nutzung dieser Webseite stimmen Sie unserer Verwendung von Cookies zu."
    },
    deleteAccount: {
      deleteAccount: "Konto löschen",
      enterPassword:
        "Bitte geben Sie zur Sicherheit Ihr Kennwort ein. Die Löschung Ihres Kontos kann nicht rückgängig gemacht werden."
    },

    signUp: {
      title: "Konto erstellen",
      heading: "Sie erhalten eine E-Mail zur Aktivierung des Kontos. Hinweis für Studierende der Hochschule Landshut: melden sie sich mit der Mail-Adresse der HAW an, um relevante Funktionen (z.B. Registriereung für SAP-Konten) zu nutzen.",
      cancel: "@:global.cancel",
      createAccount: "@:landing.signUp",
      retypePassword: "Kennwort erneut eingeben",
      passwordMessage: "@:global.passwordMessage",
      passwordsDoNotMatch: "Kennwörter sind nicht identisch",
      termsAndConditions:
        "Ich habe die nachfolgenden Nutzungsbedingungen zur Kenntnis genommen."
    },

    signIn: {
      title: "Anmelden",
      heading: "Sie erhalten eine E-Mail zur Aktivierung des Kontos",
      cancel: "@:global.cancel",
      signIn: "@:title",
      passwordMessage: "@:global.passwordMessage",
      forgotPassword: "Kennwort vergessen"
    },

    landing: {
      signUp: "Konto erstellen",
      signIn: "Anmelden"
    }
  },
  en: {
    global: {
      cookieQuestion:
        "We use cookies to provide you with the best experience on our website and to improve our communications with you.If you continue without changing your settings, we’ll assume you’re happy to receive all cookies on this website.If you wish, however, you can change your cookie settings at any time."
    }
  }
};

export const i18n = new VueI18n({
  locale: "de",
  messages
});
